import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-management2',
  templateUrl: './profile-management2.component.html',
  styleUrls: ['./profile-management2.component.css']
})
export class ProfileManagement2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
